module.exports = __webpack_public_path__ + "static/img/bb2.0cd009d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bb2.jpg
// module id = oJ4C
// module chunks = 1